import { Model } from '@vuex-orm/core'

export default class StudentTravel extends Model {
    
    static entity = 'student_travel'
  
    static primaryKey = ['travel_id', 'student_id']
  
    static fields () {
        return {
            travel_id: this.attr(null),
            student_id: this.attr(null)
        }
    }
}